import React from "react";
import MuiBox from "../MuiBox";
import MuiTypography from "../MuiTypography";
import { Button, useMediaQuery } from "@mui/material";
import Input from "../Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { openCenterModal } from "store/slices/CenterModal.slice";
import ChangeName from "components/molecules/ChangeName";
import { useTranslation } from "react-i18next";
import { FName, LName } from "utils/validation/CommonValidation";

const FirstLastNameInfoCard = ({
  inputName = "firstName",
  title = "Display First Name",
  disabled = false,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isMdDown = useMediaQuery("(max-width:900px)");
  const isSmDown = useMediaQuery("(max-width:450px)");
  const { profile } = useSelector((state) => state.profile);

  const handleSubmit = (values, { setSubmitting }) => {
    dispatch(
      openCenterModal({
        content: (
          <ChangeName
            type={inputName}
            value={values}
            oldValue={
              inputName === "firstName"
                ? profile?.first_name
                : profile?.last_name
            }
          />
        ),
      }),
    );
    setSubmitting(false);
  };

  const getProfileValue = () => {
    switch (inputName) {
      case "firstName":
        return profile?.first_name;
      case "lastName":
        return profile?.last_name;
      case "email":
        return profile?.email;
      default:
        return "";
    }
  };

  const formik = useFormik({
    initialValues: {
      [inputName]: getProfileValue(),
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      [inputName]: inputName === "firstName" ? FName(t) : LName(t),
    }),
    onSubmit: handleSubmit,
  });

  return (
    <MuiBox
      onSubmit={(e) => {
        e.preventDefault();
        formik.handleSubmit();
      }}
      component={"form"}
      sx={{
        display: "flex",
        flexDirection: isSmDown ? "column" : "row",
        alignItems: "start",
        justifyContent: "space-between",
        gap: isSmDown ? "10px" : "20px",
      }}
    >
      <MuiBox
        sx={{
          width: isMdDown ? "fit-content" : "100%",
        }}
      >
        <MuiTypography variant="16" fontWeight="400" color="text.lightgray">
          {title}
        </MuiTypography>
      </MuiBox>
      <MuiBox
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "start",
          gap: "12px",
        }}
      >
        <Input
          maxCharacter={25}
          placeholder={
            inputName === "firstName"
              ? t("setting.enterNewFirstName")
              : t("setting.enterNewLastName")
          }
          name={inputName}
          value={formik.values[inputName]}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorMsg={formik.errors[inputName]}
          error={formik.touched[inputName] && formik.errors[inputName]}
          isBorderColor={true}
          isSpace={true}
          isTextOnly={true}
          isFirstCapital
        />

        {!disabled && (
          <Button
            type="submit"
            variant="whiteContained"
            disabled={
              !formik.values[inputName] ||
              formik.values[inputName] ===
                (inputName === "firstName"
                  ? profile?.first_name
                  : profile?.last_name)
            }
            sx={{
              width: "fit-content",
              height: "40px",
              border: "2px solid",
              borderColor: "background.blue600",
              flexShrink: 0,
              "&.Mui-disabled": {
                backgroundColor: "primary.dark",
                border: "none",
                color: "text.white",
                opacity: 0.5,
              },
            }}
          >
            <MuiTypography
              variant="14"
              component={"span"}
              textAlign={"center"}
              fontWeight={"500"}
              // color="primary.main"
              color="inherit"
            >
              {t("setting.update")}
            </MuiTypography>
          </Button>
        )}
      </MuiBox>
    </MuiBox>
  );
};

export default FirstLastNameInfoCard;
